import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode.react';
import axios from 'axios'; // Import Axios

const Generatedqr = ({upiId,name}) => {
  const [qrImage, setQrImage] = useState('');

  useEffect(() => {
    // Function to generate QR code
    const generateQrCode = () => {
      // Prepare the request body
      const requestBody = {
        name: name&&name?name:"",
        vpa: upiId&&upiId?upiId:""
      };

      // Make the POST request to the UPI QR generation API using Axios
      axios.post('https://upiqr.in/api/qr', requestBody, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        console.log('API response:', response.data); // Log the API response data
        // Set the QR image received from the API response
        setQrImage(response.data);
      })
      .catch(error => {
        console.error('Error generating QR code:', error);
      });
    };

    // Call the function to generate QR code
    generateQrCode();
  }, []); // Effect runs only once on component mount

  return (
    <>
    <div>
      {qrImage ? <img className=' h-32 w-32' src={`data:image/svg+xml;utf8,${encodeURIComponent(qrImage)}`} alt="QR Code" />:<>Loading...</>}
    </div>
    </>
  );
};

export default Generatedqr;
